import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export const useGetManufacturerById = (id: string, enabled = true) => {
    return useQuery({
        queryKey: ['manufacturer', id],
        queryFn: async () => (await api.get(`/manufacturer/get/${id}`)).data,
        enabled: !!id && enabled,
    });
};